var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVias(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vias",
    xmlns: "http://www.w3.org/2000/svg",
    width: 186.066,
    height: 186.067,
    viewBox: "0 0 186.066 186.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #554586;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-1",
    d: "M214.961,156a50.154,50.154,0,0,0-46.153,69.775h-37.37v-18.9a3.634,3.634,0,1,0-7.268,0v22.531a3.634,3.634,0,0,0,3.634,3.634h44.841a50.332,50.332,0,0,0,3.365,4.685c.058.083.116.167.182.247l31.322,40.132H190.478a3.634,3.634,0,0,0,0,7.268h49.079a3.634,3.634,0,0,0,0-7.268H222.4l31.5-40.372.036-.051A50.135,50.135,0,0,0,214.961,156Zm33.256,77.222-.131.167-33.125,42.447-32.787-42.007a3.773,3.773,0,0,0-.291-.4,42.883,42.883,0,1,1,66.334-.222Z",
    transform: "translate(-79.045 -99.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-1",
    d: "M350.2,234.63a3.634,3.634,0,0,0-6.9,2.228,22.532,22.532,0,1,1-15.369-14.776,3.635,3.635,0,0,0,1.937-7.007,29.8,29.8,0,1,0,20.351,19.552Z",
    transform: "translate(-185.916 -136.214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-1",
    d: "M421.159,236.171l-.026-.037a3.634,3.634,0,1,0-5.139,5.139l.033.033a3.634,3.634,0,1,0,5.139-5.139Z",
    transform: "translate(-264.14 -149.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-1",
    d: "M85.158,420H3.634a3.634,3.634,0,0,0,0,7.268h77.89V449.8a3.634,3.634,0,1,0,7.268,0V423.634A3.634,3.634,0,0,0,85.158,420Z",
    transform: "translate(0 -267.367)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-1",
    d: "M66.315,0a3.634,3.634,0,0,0-3.634,3.634V29.8H3.634a3.634,3.634,0,0,0,0,7.268H66.315a3.634,3.634,0,0,0,3.634-3.634V3.634A3.634,3.634,0,0,0,66.315,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-1",
    d: "M32.2,154H4.634a3.634,3.634,0,1,0,0,7.268H28.565V224.5H4.634a3.634,3.634,0,1,0,0,7.268H32.2a3.634,3.634,0,0,0,3.634-3.634v-70.5A3.634,3.634,0,0,0,32.2,154Z",
    transform: "translate(-0.637 -98.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-1",
    d: "M130.373,252.066a3.634,3.634,0,1,0,1.065,2.569A3.634,3.634,0,0,0,130.373,252.066Z",
    transform: "translate(-79.044 -159.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-1",
    d: "M172.079,154H127.8a3.634,3.634,0,0,0-3.634,3.634V177.8a3.634,3.634,0,1,0,7.268,0V161.268h40.64a3.634,3.634,0,1,0,0-7.268Z",
    transform: "translate(-79.045 -98.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-1",
    d: "M285.924,0a3.634,3.634,0,0,0-3.634,3.634V29.8H228.068V3.634a3.634,3.634,0,0,0-7.268,0v29.8a3.634,3.634,0,0,0,3.634,3.634h61.489a3.634,3.634,0,0,0,3.634-3.634V3.634A3.634,3.634,0,0,0,285.924,0Z",
    transform: "translate(-140.559 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-1",
    d: "M461.259,29.8h-15.99V3.634a3.634,3.634,0,0,0-7.268,0v29.8a3.635,3.635,0,0,0,3.635,3.634h19.624a3.634,3.634,0,0,0,0-7.268Z",
    transform: "translate(-278.826 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-1",
    d: "M475.531,154H464.054a3.634,3.634,0,0,0,0,7.268h11.477a3.634,3.634,0,0,0,0-7.268Z",
    transform: "translate(-293.098 -98.035)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVias);
export default __webpack_public_path__ + "static/media/Vias.cce9015d4f7c7dd09e3839b385d44f4b.svg";
export { ForwardRef as ReactComponent };